import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'cambodia_does_fac_include_entire_period_continuous_employment'

export const dataPointDefinition = {
  retracedId: 'cambodia_does_fac_include_entire_period_continuous_employment',
  name: 'Cambodia: Does the facility include the entire period of continuous employment, as legally required, when determining wo',
  description:
    'This question is specific to Cambodia only. Please consult the Law Overlay for more information on applicable legal requirements. ',
  meta: {
    slcpMeta: {
      key: 'rh-emp-12',
      number: 'RH-EMP-28',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'rh-emp-12', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34410,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
